import React, { PureComponent } from 'react'
import { TableRow, TableCell, MenuItem, Tooltip } from '@material-ui/core'

import { convertToFixed, toPercentage, onChangeEditHOF } from '../../../utils/common'
import { TaxProcessingOrderOptions } from '../../../utils/constants'
import { forEveryKey } from '../../../utils/array'

import {
  EditableTextField,
  EditableSelect,
  EditableSwitch,
  EditableNumericInput,
} from '../../common/EditableComponents'
import { HtmlTooltip } from '../ExciseTaxOption'
import InfoIcon from '@material-ui/icons/Info'
import { Grid } from '@material-ui/core'

export default class ComplexTerritoryTaxItem extends PureComponent {
  TaxProcessingOrderMenuItems = forEveryKey(TaxProcessingOrderOptions, (value, label) => (
    <MenuItem value={value} key={value}>
      {label}
    </MenuItem>
  ))

  onChange = onChangeEditHOF(this.props.onChange)

  componentDidUpdate(prevProps) {
    const {
      tax,
      isNalTaxesOnly,
      nalExciseAfterCityTax,
      enableDeliveryFeeBeforeExciseTax,
      enableSurchargeFeeBeforeExciseTax,
    } = this.props
    if (prevProps.nalExciseAfterCityTax !== nalExciseAfterCityTax) {
      if (isNalTaxesOnly && tax.territory === 'City' && nalExciseAfterCityTax) {
        this.props.onChange('activeExciseTax', false)
      }
    }
    if (prevProps.enableDeliveryFeeBeforeExciseTax !== enableDeliveryFeeBeforeExciseTax) {
      if (isNalTaxesOnly && tax.territory === 'City' && tax.taxOrder !== 'PreTaxed') {
        if (enableDeliveryFeeBeforeExciseTax) {
          this.props.onChange('activeDeliveryFeeTax', true)
        } else if (!enableDeliveryFeeBeforeExciseTax && !enableSurchargeFeeBeforeExciseTax) {
          this.props.onCancel()
        }
      }
    }
    if (prevProps.enableSurchargeFeeBeforeExciseTax !== enableSurchargeFeeBeforeExciseTax) {
      if (isNalTaxesOnly && tax.territory === 'City' && tax.taxOrder !== 'PreTaxed') {
        if (enableSurchargeFeeBeforeExciseTax) {
          this.props.onChange('activeSurchargeTax', true)
        } else if (!enableDeliveryFeeBeforeExciseTax && !enableSurchargeFeeBeforeExciseTax) {
          this.props.onCancel()
        }
      }
    }
    if (prevProps.tax && tax && prevProps.tax.taxOrder !== tax.taxOrder) {
      if (tax.taxOrder !== 'PreTaxed' && enableDeliveryFeeBeforeExciseTax) {
        this.props.onChange('activeDeliveryFeeTax', true)
      }
    }
    if (prevProps.tax && tax && prevProps.tax.taxOrder !== tax.taxOrder) {
      if (tax.taxOrder !== 'PreTaxed' && enableSurchargeFeeBeforeExciseTax) {
        this.props.onChange('activeSurchargeTax', true)
      }
    }
  }

  onChangeTaxRate = (value) => {
    this.props.onChange('taxRate', value)
  }

  onKeyDown = (e) => {
    if (
      e.keyCode !== 8 &&
      e.keyCode !== 37 &&
      e.keyCode !== 39 &&
      e.target.selectionStart === (e.target.value || '').length &&
      e.target.selectionStart === e.target.selectionEnd &&
      e.target.value > 0
    ) {
      e.preventDefault()
      return false
    }
  }

  render() {
    const {
      tax,
      editMode,
      showExcise = false,
      showDeliveryFee = true,
      isNonCannabis = false,
      isNalTaxesOnly,
      nalExciseAfterCityTax,
      enableDeliveryFeeBeforeExciseTax,
      surchargeTerritoryTaxFlag,
      enableSurchargeFeeBeforeExciseTax,
      isCDTFAEnabled = false,
    } = this.props
    const selectedTaxOrder = TaxProcessingOrderOptions[tax.taxOrder]
    const disabledEditCityTax = isNalTaxesOnly && nalExciseAfterCityTax && tax.territory === 'City'
    const disabledEditCityTaxDeliveryFee =
      isNalTaxesOnly && enableDeliveryFeeBeforeExciseTax && tax.territory === 'City'
    const disabledEditCityTaxSurchargeFee =
      isNalTaxesOnly && enableSurchargeFeeBeforeExciseTax && tax.territory === 'City'
    const isStateTax = tax && tax.territory === 'State'
    return (
      <TableRow>
        <TableCell>{tax.territory}</TableCell>
        <TableCell>
          <EditableTextField
            valueToRender={(tax && tax.displayName) || ''}
            value={(tax && tax.displayName) || ''}
            name="displayName"
            editMode={false}
            onChange={this.onChange('displayName')}
            type="text"
          />
        </TableCell>
        <TableCell>
          {/* <EditableTextField
                        valueToRender={tax.taxRate}
                        editMode={editMode}
                        value={convertToFixed(tax.taxRate)}
                        valueToRender={toPercentage(tax.taxRate)}
                        onChange={this.onChange('taxRate')}
                        type="number"
                    /> */}
          <EditableNumericInput
            placeholder="Tax Rate"
            valueToRender={toPercentage(tax && tax.taxRate, 4)}
            value={convertToFixed(tax && tax.taxRate, 4)}
            className="numeric-material-input"
            mobile={false}
            onChange={this.onChangeTaxRate}
            min={0}
            strict
            precision={4}
            editMode={editMode}
            onKeyDown={this.onKeyDown}
          />
        </TableCell>
        <TableCell>
          <EditableSwitch
            valueToRender={tax && tax.compound ? 'Yes' : 'No'}
            checked={tax && tax.compound}
            editMode={editMode}
            onChange={this.onChange('compound', true)}
          />
        </TableCell>
        <TableCell>
          <EditableSelect
            value={tax && tax.taxOrder}
            onChange={this.onChange('taxOrder')}
            valueToRender={selectedTaxOrder}
            editMode={editMode}
          >
            {this.TaxProcessingOrderMenuItems}
          </EditableSelect>
        </TableCell>
        <TableCell>
          <EditableSwitch
            valueToRender={tax && tax.active ? 'Yes' : 'No'}
            checked={tax && tax.active}
            editMode={editMode}
            onChange={this.onChange('active', true)}
          />
        </TableCell>
        {!isNonCannabis &&
          (showExcise ? (
            <TableCell>
              <EditableSwitch
                valueToRender={tax && tax.activeExciseTax ? 'Yes' : 'No'}
                checked={tax && tax.activeExciseTax}
                editMode={editMode && !disabledEditCityTax}
                onChange={this.onChange('activeExciseTax', true)}
              />
            </TableCell>
          ) : null)}
        {showDeliveryFee ? (
          <TableCell>
            <Grid container alignItems="center">
              <EditableSwitch
                valueToRender={tax && tax.activeDeliveryFeeTax ? 'Yes' : 'No'}
                checked={tax && tax.activeDeliveryFeeTax}
                editMode={editMode && !disabledEditCityTaxDeliveryFee}
                onChange={this.onChange('activeDeliveryFeeTax', true)}
                disabled={tax.taxOrder === 'PreTaxed'}
              />
              {tax.taxOrder === 'PreTaxed' || disabledEditCityTaxDeliveryFee ? (
                <HtmlTooltip
                  placement="bottom"
                  title={
                    tax.taxOrder === 'PreTaxed'
                      ? 'Delivery fees can only be taxed by “post-tax” tax rates'
                      : 'City tax includes delivery fee tax before excise tax'
                  }
                >
                  <InfoIcon style={{ color: '#03a9f4', marginLeft: '10px' }} />
                </HtmlTooltip>
              ) : null}
            </Grid>
          </TableCell>
        ) : null}
        {surchargeTerritoryTaxFlag ? (
          <TableCell>
            <Grid container alignItems="center">
              <EditableSwitch
                valueToRender={tax && tax.activeSurchargeTax ? 'Yes' : 'No'}
                checked={tax && tax.activeSurchargeTax}
                editMode={editMode && !disabledEditCityTaxSurchargeFee}
                onChange={this.onChange('activeSurchargeTax', true)}
                disabled={tax.taxOrder === 'PreTaxed'}
              />
            </Grid>
          </TableCell>
        ) : null}
        {isCDTFAEnabled && isStateTax ? (
          <TableCell>
            <Grid container alignItems="center">
              <EditableSwitch
                valueToRender={tax && tax.activeCDTFATax ? 'Yes' : 'No'}
                checked={tax && tax.activeCDTFATax}
                editMode={editMode}
                onChange={this.onChange('activeCDTFATax', true)}
              />
            </Grid>
          </TableCell>
        ) : (
          <TableCell></TableCell>
        )}
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TaxOption/ComplexTaxOptions/ComplexTerritoryTaxItem.js